<div class=" pad">
    <div class="calsoft-vertical-navigation-content" #navigationContent>
    <calsoft-layout [pageNated]="true" [value]="2"></calsoft-layout>
    </div>
</div>